import type { TypedUseSelectorHook } from 'react-redux';
import { shallowEqual, useDispatch as useDispatchRedux, useSelector as useSelectorRedux } from 'react-redux';
import rootReducer from 'redhotpie-shared-lib/reducers';
import configureStore from '../store/configureStore';
import * as myStore from '../store/myStore';

// import type { AppDispatch, AppStore, RootState } from './store';
myStore.init(configureStore);
const store = myStore.getStore();

export type RootState = ReturnType<typeof rootReducer>;
// export type RootState = ReturnType<typeof rootReducer>;
export type Dispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export * from 'react-redux';
export const useDispatch: () => Dispatch = useDispatchRedux;
// export const useSelector: TypedUseSelectorHook<RootState> = useSelectorRedux;
export const useSelector: TypedUseSelectorHook<RootState> = selector => {
  return useSelectorRedux(selector, shallowEqual);
};
